<template>
  <div class="regular-header">
    <navbar />

  <halfBanner>
    <template v-slot:intro-tekst>
      <h1>Mobilyze</h1>
      <p>Mobilyze staat voor duurzaamheid en dan met name het verduurzamen van wagenparken bij grote organisaties. Om meer body aan hun merk te geven hebben wij voor Mobilyze hun oude <a>branding</a> op mogen frissen. Benieuwd hoe we dat hebben gedaan? Scroll dan gauw verder!</p>
      <a v-scroll-to="'#contact'">Read more!</a>
    </template>

    <template v-slot:intro-animation>
        <div class="intro-animation">
          <lottie :options="headerImages[0].defaultOptions"/>    
          <a> {{ headerImages[headerIndex].string }}  </a>
        </div>
    </template>

  </halfBanner>  

<div class="case-page">

  <titel>
    <template v-slot:intro-tekst>
      <h2>Rebranding Mobilyze</h2>
      <p>Na een intense brandingsessie waarin we alle ambities en toekomstdromen van het energieke bedrijf hebben besproken konden wij bakken vol ideeën uitvoeren en de mensen achter Mobilyze goed leren kennen. In deze casestudy doorlopen wij het hele rebranding traject net zo clean als een elektrische wagen die net van de laadpaal afkomt!</p>
    </template>
  </titel>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case odd">
      <div class="img-box">
        <img src="../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_1.jpg">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Van oud naar nieuw</h3>
          <p>De oude kleurstelling van Mobilyze was nog vrij zakelijk en stroef. Dat in combinatie met een lettertype waarmee het lastig was om andere brand uitingen mee te maken heeft ons doen besluiten dit op de schop te gooien. In de basis blijven we bij groen (wat staat voor duurzame energie) maar met dit nieuwe kleurenpalet en veelzijdigere lettertypes voegen we meer dynamiek en energie toe aan deze jonge onderneming.</p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case even">
      <div class="text-box">
        <div class="content padding-left">
          <h3>Tweaking the mark</h3>
          <p>Het oude beeldmerk van Mobilyze was in de basis goed. Wij hebben deze bewust zo gelaten. Toch hebben we hier een paar iteratieslagen op gedaan om het in lijn te trekken met de nieuwe kleuren.  Het wiel dat vooruit beweegt staat voor de mobiliteit die zij teweeg willen brengen. Na wat geëxperimenteerd te hebben met alternatieve vormen hebben we uiteindelijk het lijnwerk van het oude beeldmerk rechtgetrokken en iets dynamischer in beeld laten komen om de vooruitgang sterker over te laten komen.</p>
        </div>
      </div>
         <div class="img-box">
        <img src="../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_3.jpg">
      </div>
    </div>
  </oddEvenGrid>

  <titelPictureMedium v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
   <template v-slot:intro-tekst>
    <h3>Enkele voorstellen</h3>
    <p>Hieronder laten we een aantal stappen in ons proces zien naar het uiteindelijke nieuwe logo van Mobilyze. In deze voorstellen hebben we ‘de afgeschoten’ beeldmerken terug naar voren laten komen om te kijken of ze in combinatie met typografie alsnog een meerwaarde toe konden voegen. Het uiteindelijke logo van Mobilyze is hieronder te zien.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_4.jpg">
  </template>
</titelPictureMedium>


  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case even">
      <div class="img-box">
        <img src="../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_2.jpg">
      </div>
       <div class="text-box">
        <div class="content padding-right">
          <h3>Vooruit met de mobiliteit</h3>
          <p>Met de nieuwe kleurstelling, opgepimpte fonts en een dynamischer beeldmerk hebben wij het oude logo van Mobilyze in een nieuw jasje gestoken. Waarbij in het oude logo vooral de letter “E” in combinatie met het beeldmerk voor beweging en mobiliteit zorgde hebben we dat concept nu doorvertaald in het volledige logo door het hele logo in een hoek van 5 graden te plaatsen.</p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

  <backgroundPattern v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="background-pattern-container">
    <div class="odd-even-grid backgroundPatern case even">
      <div class="text-box">
        <div class="content padding-left">
          <h3>It all comes together</h3>
          <p>Buiten de nieuwe kleurstelling, typografie en logo voor Mobilyze hebben we vanuit het nieuwe beeldmerk ook een patroon ontwikkeld dat gebruikt kan worden voor briefpapier, offertes, banners , visitekaartjes en social media profielen.</p>
        </div>
      </div>
      <div class="img-box">
        <img src="../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_6.png">
      </div>
    </div>
    </div>
  </backgroundPattern>

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Illustrating the brand</h2>
    <p>Voortbordurend op het nieuwe logo en kleurstellingen hebben we een iconenset ontworpen binnen de nieuwe huisstijl. Deze staan voor de vraag- of probleemstukken waar organisaties mee te maken kunnen hebben en de toolset die Mobilyze gebruikt om die problemen op te lossen.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_7.jpg">
  </template>
</titelPictureBig>

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Let's talk about it</h2>
    <p>Mobilyze had de behoefte aan een product waarbij ze aan hun potentiële klanten, in een oogopslag, kunnen laten zien wat ze doen en wat ze kunnen betekenen voor hun organisatie.
Daarom hebben wij een overzichtelijke praatplaat ontworpen die zowel online gedownload kan worden als mee worden genomen op gesprek.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_8.jpg">
  </template>
</titelPictureBig>



<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Website</h2>
    <p>Laten we beginnen met een onepager. Die vraag krijgen we vaak. In tegenstelling tot sommmige oplossingen paste dit perfect. De website verteld beeldend het verhaal van Mobilyze. Wie ben je, wat doe je, waarom doe je het en hoe doe je het. </p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_9.png">
  </template>
</titelPictureBig>


<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>The devil is in the details</h2>
    <p>Bij zo’n vooruitstrevend bedrijf ga je natuurlijk geen simpele testimonial slider gebruiken. 
      Mobilyze is continue bezig met verandering binnen de mobiliteitsector, alle klanten testimonials komen dan ook voorbij in een gestileerd autowiel dat slim is opgebouwd uit het beeldmerk van Mobilyze zelf. </p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_10.png">
  </template>
</titelPictureBig>


<endCase v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
  <template v-slot:intro-tekst>
    <h2>Mobilyze samengevat</h2>
    <p>Mobilyze heeft na deze rebranding al veel positieve reacties ontvangen. Waar wij vooral in hebben mogen helpen is hun verhaal en dienstverlening beter in beeld te brengen. De praatplaat, het logoo en de website die wij hiervoor ontwikkeld hebben zijn een simpele oplossing die nu al zijn vruchten afwerpt in de gesprekken die ze voeren! We blijven koffie met elkaar drinken, ook buiten onze werkrelatie om.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/Folded_Paper_Werk_Thanks.jpg">
  </template>
  <template v-slot:outro-tekst>
    <h4>Bekijk ook onze andere toffe cases</h4>
  </template>
</endCase>

 <caseGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
    <div class="row">
      <ul>
        <li>
          <router-link class="router-link" to="/werk/wageningen-universiteit">
            <div class="column tca">
              <img src="../../assets/Folded_Paper_case_thumnail_Unlock.jpg">
              <span class="font-size-custom-max-12">Unlock Wageningen Universiteit & Research<br>Branding & product design</span>
            </div>
           </router-link>
        </li>

        <li>
          <router-link class="router-link" to="/werk/avans-hogeschool">
            <div class="column avans">
              <img src="../../assets/Folded_Paper_case_thumbnail_Avans_Hogeschool.jpg">
              <span class="font-size-custom-max-12">Avans Hogeschool<br>Product design</span>
            </div>
          </router-link>
        </li>
    </ul>
  </div>
</caseGrid>


</div>
<footerComponent></footerComponent>

</div>

</template>

<script>
import navbar from '@/components/generalLayout/navbar.vue';
import halfBanner from '@/components/generalLayout/halfBanner.vue';
import titel from '@/components/generalLayout/werk/titel.vue';
import oddEvenGrid from '@/components/generalLayout/oddEvenGrid.vue';
import titelPictureMedium from '@/components/generalLayout/werk/titelPictureMedium.vue';
import titelPictureBig from '@/components/generalLayout/werk/titelPictureBig.vue';
import endCase from '@/components/generalLayout/werk/endCase.vue';
import fullWidthPicture from '@/components/generalLayout/werk/fullWidthPicture.vue';
import backgroundPattern from '@/components/generalLayout/werk/backgroundPattern.vue';
import caseGrid from '@/components/generalLayout/caseGrid.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';


import Lottie from '../../lottie.vue';
import * as animationMobilyze from '@/assets/cases/mobilyze/headeranimatie/mobilyze.json';


export default {
    data () {
    return {
      headerImages: [
	      { defaultOptions: {animationData: animationMobilyze.default}, string:'Branding / Illustratie', },
      ],
    }
  },
  components:{
    navbar,
    halfBanner,
    titel,
    oddEvenGrid,
    titelPictureMedium,
    titelPictureBig,
    endCase,
    fullWidthPicture,
    backgroundPattern,
    caseGrid,
    footerComponent,
    'lottie': Lottie,
  },

  methods:{
    randomNumber(maxValue){
      return Math.floor(Math.random() * Math.floor(maxValue));
    }
  },
  computed:{
    headerIndex(){
      return this.randomNumber(this.headerImages.length);
    }
  },
}


</script>

<style lang="scss">

.home-bg-color{
  background: rgba(22,141,0,0.15) !important;
  background-repeat: no-repeat;
  background-size: cover;
}

.fold-container .first-content .intro-tekst{
  animation-delay: 1.4s;
}

.regular-header .fold-container .home-bg-color{
  animation-delay: .6s;
}

.regular-header .fold-container .case-hightlight-img .intro-animation{
  animation-delay: 1s;
}

body .case .img-box img, .odd-even-grid .text-box img{
  max-height: 600px !important;
  width: auto !important;
  margin:  auto;
  display: block;
}

.case-content{
  h2{
    padding-top: layout-val-64(0.5);
    padding-bottom: layout-val-8(1);
  }
}

.case-img-bg{
  background-color: #FFF8E7;
}

@media screen and (max-width: 960px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 400px !important;
  }
}

@media screen and (max-width: 830px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 300px !important;
  }
}

@media screen and (max-width: 720px) {
  .content-grid-two-rows{
    .firstenergy, .loud, .newschain, .tca{
      float: none;
    }
  }
}

@media screen and (max-width: 640px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 90% !important;
  }
  .home-bg-color{
    width: 100% !important;
    max-width: 100% !important;
    left:12px;
    border-right: 24px solid $white !important;
  }
}
</style>
